import React, { useState, useEffect } from 'react';

const OTP_API = process.env.REACT_APP_OTP_API_URL
  || 'https://qdtjpudqk3.execute-api.ap-northeast-2.amazonaws.com/prod';

export default function OtpInput({ phoneNumber, onVerified }) {
  const [code, setCode] = useState('');
  const [sentAt, setSentAt] = useState(null);
  const [cooldown, setCooldown] = useState(0);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState('');
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (cooldown > 0) {
      const t = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [cooldown]);

  const sendCode = async () => {
    if (!phoneNumber) { setError('전화번호를 먼저 입력해주세요'); return; }
    setError(''); setSending(true);
    try {
      const res = await fetch(`${OTP_API}/otp/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || '발송 실패');
      } else {
        setSentAt(Date.now());
        setCooldown(60);
      }
    } catch (err) {
      setError('네트워크 오류');
    }
    setSending(false);
  };

  const verifyCode = async () => {
    if (code.length !== 6) { setError('6자리 코드를 입력해주세요'); return; }
    setError(''); setVerifying(true);
    try {
      const res = await fetch(`${OTP_API}/otp/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber, code }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || '인증 실패');
      } else {
        setVerified(true);
        onVerified(data.otpToken);
      }
    } catch (err) {
      setError('네트워크 오류');
    }
    setVerifying(false);
  };

  if (verified) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#4caf50', fontSize: '0.9rem', marginTop: 8 }}>
        ✅ 전화번호 인증 완료
      </div>
    );
  }

  return (
    <div style={{ marginTop: 12 }}>
      {!sentAt ? (
        <button type="button" onClick={sendCode} disabled={sending || !phoneNumber}
          className="btn btn-outline" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>
          {sending ? '발송 중...' : '인증번호 받기'}
        </button>
      ) : (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            placeholder="6자리 코드"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            className="input"
            style={{ width: 140, fontFamily: 'monospace', letterSpacing: 4 }}
          />
          <button type="button" onClick={verifyCode} disabled={verifying || code.length !== 6}
            className="btn btn-primary" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>
            {verifying ? '확인 중...' : '확인'}
          </button>
          <button type="button" onClick={sendCode} disabled={cooldown > 0 || sending}
            style={{ background: 'transparent', border: 'none', color: cooldown > 0 ? '#888' : 'var(--primary)', cursor: cooldown > 0 ? 'default' : 'pointer', fontSize: '0.8rem' }}>
            {cooldown > 0 ? `재전송 (${cooldown}s)` : '다시 받기'}
          </button>
        </div>
      )}
      {error && <div style={{ color: '#ff5252', fontSize: '0.8rem', marginTop: 6 }}>{error}</div>}
    </div>
  );
}
